<template lang="pug">
    .container()
        .title-container
            .title-group
                p.step 
                    strong STEP 02: 
                    | Select a conference or create new one 
                h3 What is the conference you are interested in?

            .button-wrap
                router-link(to="/new-event").button Create new

        .event-categories.conference-categories
            Conference(v-if="allConferences.public_events" v-for="conference in allConferences.public_events" :key="conference.id" :conference="conference" @pickedConference="pickedConference" @clickedConference="clickedConference")

        .button-row
            a.back(href="" @click.prevent="$router.go(-1)") 
                i.fa.fa-angle-left
                | Back

            router-link( v-if="selectedConferenceSlug" :to="{ name: 'conference', params: { 'slug': selectedConferenceSlug, 'id': selectedConferenceId } }" :class="{ active: isChecked }").next Proceed

        //- conference popup
        conferencepoup(:singleConference="getConferenceDetails" :seats="availableSeats" ref="conferencePopup")            
        
</template>

<script>
    import Conference from './Conference';
    import conferencepoup from './ConferencePopup';
    import { mapGetters, mapActions } from 'vuex';

    export default {
        name: 'ConferenceCategory',
        data() {
            return {
                isChecked: false,
                selectedConferenceId: null,
                selectedConferenceSlug: null,
                event_slug: `${location.pathname.split('/')[2]}`,
                availableSeats: 0
            }
        },
        components: {
            Conference,
            conferencepoup
        },
        computed: {
            ...mapGetters(['allConferences', 'getConferenceDetails']),
        },
        methods: {
            ...mapActions(['fetchConferences', 'getConference']),
            pickedConference(selectedConference) {
                if(selectedConference) {
                    this.selectedConferenceId = selectedConference.id;
                    this.selectedConferenceSlug = selectedConference.slug;

                    if(selectedConference.slug) {
                        this.isChecked = true;
                    }
                }
            },
            clickedConference(selectedConference) {
                if(selectedConference) {
                    this.availableSeats = selectedConference.availableSeats;

                    this.getConference(selectedConference.slug).then(() => {
                        this.$refs.conferencePopup.toggle();
                    });
                }
            }
        },
        created() {
            this.fetchConferences(window.location.pathname.split('/')[2]);
        }
    };
</script>

